module.exports = __webpack_public_path__ + "media/images/icon_search_btn_new_on-fe50da020300182e24551935616b75f4.png";